import iconBody from '../img/body-outline.png';
import iconBrain from '../img/brain-outline.png';
import iconCombination from '../img/combination-outline.png';
import iconFemalePelvis from '../img/female-pelvis-outline.png';
import iconHead from '../img/head-outline.png';
import iconHeadNeck from '../img/headneck-outline.png';
import iconAbdomenChest from '../img/torso-outline.png';
import iconTorso from '../img/torso-outline.png';


export const BODY_PART_TAB_ALL = 'All';
export const BODY_PART_TAB_BRAIN = 'Brain';
export const BODY_PART_TAB_HEAD = 'Head';
export const BODY_PART_TAB_HEADNECK = 'Head and Neck';
export const BODY_PART_TAB_ABDOMEN_CHEST = 'Abdomen and Chest';
export const BODY_PART_TAB_TORSO = 'Torso';
export const BODY_PART_TAB_PELVIS = 'Pelvis';
export const BODY_PART_TAB_COMBINATION = 'Combination';
export const BODY_PART_TAB_WHOLE_BODY = 'WholeBody';

export const getBodyPartIcon = (bodyPart: string): React.ReactNode => {
    switch (bodyPart) {
        case BODY_PART_TAB_HEAD:
            return (<img src={iconHead} width={30} />);
        case BODY_PART_TAB_BRAIN:
            return (<img src={iconBrain} width={30} />);
        case BODY_PART_TAB_HEADNECK:
            return (<img src={iconHeadNeck} width={30} />);
        case BODY_PART_TAB_TORSO:
            return (<img src={iconTorso} width={30} />);
        case BODY_PART_TAB_ABDOMEN_CHEST:
            return (<img src={iconAbdomenChest} width={30} />);
        case BODY_PART_TAB_PELVIS:
            return (<img src={iconFemalePelvis} width={28} />);
        case BODY_PART_TAB_COMBINATION:
            return (<img src={iconCombination} width={30} />);
        case BODY_PART_TAB_WHOLE_BODY:
            return (<img src={iconBody} width={30} />);
        default:
            return null;
    }
}
